import React from "react";
import { View } from "react-native";
const Spacer = ({ style, ...rest }) => (<View style={[{ flex: 1, alignSelf: "stretch" }, style]} {...rest}/>);
export default Spacer;
